export enum ReviewTarget {
  ALL = 'ALL',
  CONSULTANT = 'CONSULTANT',
  DOCTOR = 'DOCTOR',
}

export enum ReviewResponseType {
  SCORE = 'SCORE',
  CHECKBOX = 'CHECKBOX',
  TEXT = 'TEXT',
  SCORE_TEXT = 'SCORE_TEXT',
}
export class ReviewQuestion {
  id: number;

  title: string;

  responseType: ReviewResponseType;

  targetBy: ReviewTarget;

  responseOptions?: string[];

  globalReviewQuestions?: GlobalReviewQuestion[];
}

export class GlobalReviewQuestion {
  title: string;
  responseOptions?: string[];
  language: Language;
}

export class Language {
  id: number;

  code: string;
}
